<template>
		<transition name="fade">
			<div v-if="msgToAppear" class="voucher-message" :class="{'red-colored': !isActive}" :style="{'height': heightBasedOnMsgLength(msgToAppear)}">
				{{msgToAppear}}
			</div>
		</transition>
</template>

<script>
export default {
	name: "CustomTransition",
	props:["msgToAppear","isActive"],
	methods: {
		heightBasedOnMsgLength(msgToAppear) {
			const initialHeight = 45;
			const fontSize = 14;
			// suppose ~30 characters are able to fit one row in this box message
			const rowsToAdd = Math.floor(msgToAppear.length / 30);
			// add dummy logic to extend box message height, with css
			return initialHeight + rowsToAdd*fontSize + "px";
		}
	},
	watch: {
		msgToAppear(newVal){
			const self = this;
			if(newVal){
				const dummyTimeoutBasedOnMessageLength = newVal.length > 50 ? 6000 : 3000;
				setTimeout(() => {
					self.$emit("msg-to-appear","");
				},dummyTimeoutBasedOnMessageLength);
			}
		}
	}
};
</script>

<style scoped lang="scss">
	.fade-enter-active, .fade-leave-active {
		transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
	}
	.fade-enter, .fade-leave-to {
		transform: translateX(10px);
  		opacity: 0;
	}
	.voucher-message{
		z-index: 1;
		position: absolute;
		bottom: 192px;
		border-radius: 10px;
		width: 80%;
		min-height: 45px !important;
		height: auto !important;
		font-size: 14px;
		background-color: #f3dda1;
		padding: 10px;
		left: 10%;
		text-align: center;
		color: #218C74;
	}
	.red-colored{
		color: rgb(201, 25, 25);
	}
</style>
